import React from "react";
import { useLang } from "@/context/LanguageContext";
import SymbolPage from "@/components/SymbolPage";

const IMG = "https://images.unsplash.com/photo-1474540412665-1cdae210ae6b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

const Adhd = () => {
  const { t } = useLang();
  return <SymbolPage data={t.adhd} image={IMG} />;
};

export default Adhd;
